import type { DocumentSearchHit } from './documentSearchNavigation';

export type EntitySearchProject = {
  id: string;
  lead_title: string;
  name: string;
  display_id: string;
  site_address: string | null;
};

export type EntitySearchHit = {
  id: string;
  title: string;
  subtitle: string;
  display_id?: string | null;
};

export type EntitySearchResponse = {
  projects: EntitySearchProject[];
  contacts: EntitySearchHit[];
  organizations: EntitySearchHit[];
  vehicles: EntitySearchHit[];
  employees: EntitySearchHit[];
  tenders: EntitySearchHit[];
};

export function emptyEntitySearchResponse(): EntitySearchResponse {
  return {
    projects: [],
    contacts: [],
    organizations: [],
    vehicles: [],
    employees: [],
    tenders: [],
  };
}

export type GlobalSearchHit =
  | { key: string; type: 'project'; project: EntitySearchProject }
  | { key: string; type: 'contact' | 'org' | 'vehicle' | 'employee'; id: string }
  | { key: string; type: 'tender'; id: string; display_id?: string | null }
  | { key: string; type: 'document'; document: DocumentSearchHit };

export function flattenGlobalSearchHits(
  entities: EntitySearchResponse,
  documents: DocumentSearchHit[],
): GlobalSearchHit[] {
  const hits: GlobalSearchHit[] = [];
  for (const project of entities.projects) {
    hits.push({ key: `project-${project.id}`, type: 'project', project });
  }
  for (const row of entities.contacts) {
    hits.push({ key: `contact-${row.id}`, type: 'contact', id: row.id });
  }
  for (const row of entities.organizations) {
    hits.push({ key: `org-${row.id}`, type: 'org', id: row.id });
  }
  for (const row of entities.vehicles) {
    hits.push({ key: `vehicle-${row.id}`, type: 'vehicle', id: row.id });
  }
  for (const row of entities.employees) {
    hits.push({ key: `employee-${row.id}`, type: 'employee', id: row.id });
  }
  for (const row of entities.tenders) {
    hits.push({
      key: `tender-${row.id}`,
      type: 'tender',
      id: row.id,
      display_id: row.display_id,
    });
  }
  for (const document of documents) {
    hits.push({ key: `document-${document.kind}-${document.id}`, type: 'document', document });
  }
  return hits;
}

export function stepSearchIndex(current: number, delta: number, count: number): number {
  if (count <= 0) return 0;
  return (current + delta + count) % count;
}
